// assets/custom-box-builder.js
(function () {
  console.log("Box builder script loaded");

  // Variant IDs (keep yours)
  const variantMapping = {
    16: 43913996992768,
    32: 43913997025536,
    48: 43913997058304,
  };

  function toHandle(str) {
    return (str || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/&/g, " and ")
      .replace(/['’]/g, "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .replace(/-+/g, "-");
  }

  function normalizeFlavorName(str) {
    return (str || "")
      .replace(/\u2019/g, "'")
      .replace(/\u2018/g, "'")
      .replace(/\u201C|\u201D/g, '"')
      .replace(/\s+/g, " ")
      .trim();
  }

  function uniqueFlavors(arr) {
    const seen = new Set();
    const out = [];

    (arr || []).forEach((item) => {
      const cleaned = normalizeFlavorName(item);
      if (!cleaned) return;

      const key = cleaned.toLowerCase();
      if (seen.has(key)) return;

      seen.add(key);
      out.push(cleaned);
    });

    return out;
  }

  function loadFirstAvailableImage(imgEl, urls, fallback) {
    if (!imgEl) return;
    const list = Array.isArray(urls) ? urls : [];
    let idx = 0;

    function done(useFallback) {
      imgEl.classList.remove("cb-skeleton");
      if (useFallback && fallback) imgEl.src = fallback;
    }
    function tryNext() {
      if (idx >= list.length) return done(true);
      const candidate = list[idx++];
      const probe = new Image();
      probe.onload = () => {
        imgEl.src = candidate;
        done(false);
      };
      probe.onerror = tryNext;
      probe.src = candidate;
    }
    tryNext();
  }

  function getFlavorsFrom(container) {
    const fallback = [
      "Almond Rococo Silk","Amaretto Almond Silk","Army Ranger Mint Silk","Baby Bleu Silk",
      "Black Forest Cake Silk","Butterbeer Silk","Canadian Maple Silk","Caramel Espresso Silk",
      "Caramel Pumpkin Cheesecake Silk","Caramel Turtle Silk","Caramel Twist Silk","Carrot Cake Silk",
      "Cherry Blossom Silk","Chocolate Silk","Confetti Cake Silk","Cookies N' Cream Silk",
      "Cookie's & Cream Silk","Dark Army Ranger Mint Silk","Dark Chocolate","Dark Lavender Silk",
      "Dark Peanut Butter Silk","Dark Raspberry Silk","Dark Rocky Road Silk","Dotted Orange Swiss",
      "Espresso Silk","Grand Marnier Silk","Hot Chili Lime Bite Silk","Hot Chili Mango Silk",
      "Irish Crème Silk","Lemon Drop Silk","Peanut Butter Silk","Rainbow Chip Silk",
      "Raspberry Lemon Drop Silk","Red Velvet Cake Silk","Rocky Road Silk","Salted Caramel Silk",
      "S’more Silk","Smokin’ Bacon Silk","Snickerdoodle Silk","Strawberry Lemonade Silk","Toffee Chip Silk",
      "White Raspberry Silk","Rum Black Walnut Silk","Anthony’s Medallion","Baby Bleu Buttons",
      "Blister Peanut Medallions","Cleo’s Medallion","Silk Brittle","Silk Caramel Turtles","Silk Gems"
    ];

    let jsonFlavors = [];
    const script = container.querySelector('script[type="application/json"][id^="flavor-list-"]');

    if (script && script.textContent) {
      try {
        let arr = JSON.parse(script.textContent);

        if (Array.isArray(arr)) {
          if (arr.length === 1 && typeof arr[0] === "string" && /[\r\n,]/.test(arr[0])) {
            arr = arr[0].split(/\r?\n|,/);
          }
          jsonFlavors = arr.map(s => normalizeFlavorName(s)).filter(Boolean);
        }
      } catch (e) {
        console.warn("Flavor list parse failed:", e);
      }
    }

    // Key fix:
    // Merge live JSON + fallback so missing items like Snickerdoodle Silk still appear.
    return uniqueFlavors([...(jsonFlavors || []), ...fallback]);
  }

  // Modal (reused)
  function getModal() {
    let overlay = document.querySelector(".cb-modal-overlay");
    if (overlay) return overlay;

    overlay = document.createElement("div");
    overlay.className = "cb-modal-overlay";
    overlay.innerHTML = `
      <div class="cb-modal" role="dialog" aria-modal="true" aria-labelledby="cb-modal-title">
        <div class="cb-modal-header">
          <div class="cb-modal-title" id="cb-modal-title"></div>
        </div>
        <div class="cb-modal-body" id="cb-modal-body"></div>
        <div class="cb-modal-actions">
          <button type="button" class="cb-modal-btn" data-action="cancel">Cancel</button>
          <button type="button" class="cb-modal-btn primary" data-action="confirm">Confirm</button>
        </div>
      </div>
    `;
    document.body.appendChild(overlay);
    return overlay;
  }

  function openModal({ title, body, confirmText = "Confirm", cancelText = "Cancel" }) {
    const overlay = getModal();
    const titleEl = overlay.querySelector("#cb-modal-title");
    const bodyEl = overlay.querySelector("#cb-modal-body");
    const confirmBtn = overlay.querySelector('[data-action="confirm"]');
    const cancelBtn = overlay.querySelector('[data-action="cancel"]');

    titleEl.textContent = title || "Confirm";
    bodyEl.innerHTML = body || "";
    confirmBtn.textContent = confirmText;
    cancelBtn.textContent = cancelText;

    overlay.classList.add("is-open");

    return new Promise((resolve) => {
      function cleanup(result) {
        overlay.classList.remove("is-open");
        confirmBtn.removeEventListener("click", onConfirm);
        cancelBtn.removeEventListener("click", onCancel);
        overlay.removeEventListener("click", onOverlay);
        document.removeEventListener("keydown", onKey);
        resolve(result);
      }
      function onConfirm() { cleanup(true); }
      function onCancel() { cleanup(false); }
      function onOverlay(e) { if (e.target === overlay) cleanup(false); }
      function onKey(e) { if (e.key === "Escape") cleanup(false); }

      confirmBtn.addEventListener("click", onConfirm);
      cancelBtn.addEventListener("click", onCancel);
      overlay.addEventListener("click", onOverlay);
      document.addEventListener("keydown", onKey);

      confirmBtn.focus();
    });
  }

  async function doubleConfirmSingleFlavor(flavor, sz) {
    const first = await openModal({
      title: "Confirm your selection",
      body: `You selected <strong>only one flavor</strong>: <strong>${flavor}</strong>.<br><br>
            Your entire <strong>${sz}-piece</strong> box will be this flavor.`,
      confirmText: "Yes, proceed",
      cancelText: "Go back"
    });
    if (!first) return false;

    const second = await openModal({
      title: "Final confirmation",
      body: `Please confirm one more time:<br><br>
            <strong>All ${sz} pieces</strong> will be <strong>${flavor}</strong>.`,
      confirmText: "Confirm",
      cancelText: "Cancel"
    });
    return !!second;
  }

  function setupSection(container) {
    console.log("Initializing box-builder in", container.id);

    const boxSize  = container.querySelector("#box-size-select");
    const search   = container.querySelector("#flavor-search");
    const grid     = container.querySelector("#flavor-grid");
    const maxLabel = container.querySelector("#max-flavors");
    const summary  = container.querySelector("#box-summary");
    const addBtn   = container.querySelector("#add-to-cart-btn");
    const clearBtn = container.querySelector("#clear-all-btn");
    const notice   = container.querySelector("#cb-notice");
    const chips    = container.querySelector("#cb-selected");
    const previewImg = container.querySelector("#box-preview-img");
    const previewLbl = container.querySelector("#preview-label");

    if (!grid || !boxSize || !notice || !chips || !addBtn || !summary) return;

    const assetsBase = container.dataset.assetsBase || "";
    const thumbExts = ["jpg", "jpeg", "png", "webp"];
    const flavors = getFlavorsFrom(container);

    let selected = {}; // { flavorName: true }

    let noticeTimer = null;
    function showNotice(html, autoHideMs = 2200) {
      notice.innerHTML = html;
      notice.classList.add("is-visible");
      if (noticeTimer) window.clearTimeout(noticeTimer);
      if (autoHideMs) noticeTimer = window.setTimeout(() => notice.classList.remove("is-visible"), autoHideMs);
    }
    function hideNotice() {
      notice.classList.remove("is-visible");
      if (noticeTimer) window.clearTimeout(noticeTimer);
      noticeTimer = null;
    }

    function getMaxFlavors() {
      const sz = parseInt(boxSize.value, 10);
      return sz === 16 ? 4 : 6;
    }

    function selectedCount() {
      return Object.keys(selected).length;
    }

    function updatePreview() {
      const sz = boxSize.value;
      const src = container.dataset["box" + sz + "Image"];
      if (previewImg && src) previewImg.src = src;
      if (previewLbl) previewLbl.textContent = `${sz}-Piece Box`;
    }

    function updateSummary() {
      const sz = parseInt(boxSize.value, 10);
      const count = selectedCount();
      const max = getMaxFlavors();
      if (maxLabel) maxLabel.textContent = max;

      if (count === 0) {
        summary.textContent = "No flavors selected.";
        addBtn.disabled = true;
        chips.innerHTML = "";
        return;
      }
      const per = Math.round(sz / count);
      summary.textContent = `Selected ${count} flavor${count > 1 ? "s" : ""} · ${per} piece${per > 1 ? "s" : ""} each`;
      addBtn.disabled = false;
    }

    function setFlavorThumb(imgEl, flavor) {
      imgEl.classList.add("cb-skeleton");
      imgEl.src = container.dataset.flavorPlaceholder;

      if (!assetsBase) {
        imgEl.classList.remove("cb-skeleton");
        return;
      }
      const handle = toHandle(flavor);
      const candidates = thumbExts.map(ext => `${assetsBase}${handle}.${ext}`);
      loadFirstAvailableImage(imgEl, candidates, container.dataset.flavorPlaceholder);
    }

    function filterFlavors() {
      const term = (search && search.value ? search.value : "").trim().toLowerCase();
      if (!term) return flavors;
      return flavors.filter(f => f.toLowerCase().includes(term));
    }

    function renderChips() {
      const keys = Object.keys(selected).sort();
      chips.innerHTML = "";
      if (!keys.length) return;

      keys.forEach(name => {
        const chip = document.createElement("span");
        chip.className = "cb-chip";
        chip.textContent = name;

        const x = document.createElement("button");
        x.type = "button";
        x.setAttribute("aria-label", `Remove ${name}`);
        x.innerHTML = "×";
        x.addEventListener("click", () => {
          delete selected[name];
          renderGrid();
          updateSummary();
        });

        chip.appendChild(x);
        chips.appendChild(chip);
      });
    }

    function enforceMaxUI() {
      const max = getMaxFlavors();
      const count = selectedCount();
      const atMax = count >= max;

      const checkboxes = grid.querySelectorAll('input[type="checkbox"][data-flavor]');
      checkboxes.forEach(cb => {
        const flavor = cb.getAttribute("data-flavor");
        const isSelected = !!selected[flavor];

        if (atMax && !isSelected) {
          cb.disabled = true;
          cb.closest(".flavor-item")?.classList.add("is-disabled");
        } else {
          cb.disabled = false;
          cb.closest(".flavor-item")?.classList.remove("is-disabled");
        }
      });

      if (atMax) {
        showNotice(`You’ve selected <strong>${max}</strong> flavors. Uncheck one to choose a different flavor.`, 1800);
      } else {
        hideNotice();
      }
    }

    function toggleFlavor(flavor, shouldSelect) {
      const maxNow = getMaxFlavors();
      const countBefore = selectedCount();
      const currentlySelected = !!selected[flavor];

      if (!currentlySelected && shouldSelect && countBefore >= maxNow) {
        showNotice(`This box allows up to <strong>${maxNow}</strong> flavors.`, 2200);
        return false;
      }

      if (shouldSelect) selected[flavor] = true;
      else delete selected[flavor];

      return true;
    }

    function renderGrid() {
      grid.innerHTML = "";

      const list = filterFlavors();
      const max = getMaxFlavors();
      if (maxLabel) maxLabel.textContent = max;

      const frag = document.createDocumentFragment();

      list.forEach(flavor => {
        const isChecked = !!selected[flavor];

        const card = document.createElement("div");
        card.className = "flavor-item" + (isChecked ? " is-selected" : "");
        card.setAttribute("data-card-flavor", flavor);
        card.setAttribute("role", "button");
        card.setAttribute("tabindex", "0");
        card.setAttribute("aria-pressed", isChecked ? "true" : "false");

        const thumb = document.createElement("img");
        thumb.className = "flavor-thumb";
        thumb.alt = flavor;
        setFlavorThumb(thumb, flavor);
        card.appendChild(thumb);

        const cb = document.createElement("input");
        cb.type = "checkbox";
        cb.checked = isChecked;
        cb.setAttribute("data-flavor", flavor);
        cb.setAttribute("aria-label", flavor);
        card.appendChild(cb);

        const lbl = document.createElement("label");
        lbl.textContent = flavor;
        card.appendChild(lbl);

        const check = document.createElement("span");
        check.className = "cb-card-check";
        check.setAttribute("aria-hidden", "true");
        check.textContent = "✓";
        card.appendChild(check);

        cb.addEventListener("change", () => {
          const ok = toggleFlavor(flavor, cb.checked);
          if (!ok) {
            cb.checked = false;
            return;
          }
          card.classList.toggle("is-selected", cb.checked);
          card.setAttribute("aria-pressed", cb.checked ? "true" : "false");
          renderChips();
          updateSummary();
          enforceMaxUI();
        });

        card.addEventListener("click", (e) => {
          if (e.target === cb) return;
          if (cb.disabled) return;

          cb.checked = !cb.checked;
          cb.dispatchEvent(new Event("change", { bubbles: true }));
        });

        card.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            if (cb.disabled) return;
            cb.checked = !cb.checked;
            cb.dispatchEvent(new Event("change", { bubbles: true }));
          }
        });

        frag.appendChild(card);
      });

      grid.appendChild(frag);
      renderChips();
      enforceMaxUI();
    }

    function clearAll() {
      selected = {};
      renderGrid();
      updateSummary();
      showNotice("Selections cleared.", 1200);
    }

    async function handleAdd(e) {
      e.preventDefault();
      const sz = parseInt(boxSize.value, 10);
      const keys = Object.keys(selected);
      const count = keys.length;
      const max = getMaxFlavors();

      if (count === 0) {
        showNotice("Please select at least <strong>one</strong> flavor.", 2400);
        return;
      }
      if (count > max) {
        showNotice(`Please reduce your selection to <strong>${max}</strong> flavors.`, 2400);
        return;
      }

      if (count === 1) {
        const ok = await doubleConfirmSingleFlavor(keys[0], sz);
        if (!ok) return;
      }

      const per = Math.round(sz / count);
      const props = {};
      keys.forEach(f => props[f] = per);

      const vid = variantMapping[sz];
      if (!vid) {
        showNotice("Configuration error: missing variant for this size.", 3000);
        return;
      }

      addBtn.disabled = true;
      const originalText = addBtn.textContent;
      addBtn.textContent = "Adding…";

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: vid, quantity: 1, properties: props })
      })
      .then(res => res.json())
      .then(() => (window.location.href = "/cart"))
      .catch(err => {
        console.error("Add to cart failed:", err);
        showNotice("Could not add to cart. Please try again.", 3000);
        addBtn.disabled = false;
        addBtn.textContent = originalText;
      });
    }

    boxSize.addEventListener("change", () => {
      const max = getMaxFlavors();
      const keys = Object.keys(selected).sort();
      if (keys.length > max) keys.slice(max).forEach(k => delete selected[k]);

      renderGrid();
      updatePreview();
      updateSummary();
      showNotice("Box size updated.", 900);
    });

    if (search) search.addEventListener("input", () => renderGrid());
    if (clearBtn) clearBtn.addEventListener("click", clearAll);
    addBtn.addEventListener("click", handleAdd);

    renderGrid();
    updatePreview();
    updateSummary();
  }

  function initAll() {
    document.querySelectorAll(".custom-box-builder").forEach(setupSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
  document.addEventListener("shopify:section:load", initAll);
})();